var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"layout-portal",attrs:{"element-loading-text":"首页配置加载中..."}},[(_vm.portal.componentPath)?_c('AsyncComponent',_vm._b({attrs:{"component-path":_vm.portal.componentPath}},'AsyncComponent',_vm.portal.componentParam,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }